import { Link } from 'react-router-dom';

interface ClosingLinkProps {
  to: string;
  label: string;
}

export default function ClosingLink({ to, label }: ClosingLinkProps) {
  return (
    <Link
      to={to}
      className="group inline-flex cursor-pointer items-center gap-3 whitespace-nowrap border-b border-[#222222] pb-1.5 text-[15px] font-medium text-[#222222] transition-colors duration-200 hover:border-[#79BC68] hover:text-[#4E8A40]"
    >
      {label}
      <span className="flex h-4 w-4 items-center justify-center transition-transform duration-200 group-hover:translate-x-1.5 motion-reduce:transform-none">
        <i className="ri-arrow-right-line text-[#79BC68]" aria-hidden="true"></i>
      </span>
    </Link>
  );
}